export const googleDimensions = {
  labLoadProductStyle: 1,
  labLoadProductColor: 2,
  labLoadProductCategory: 3,
  postalCode: 6,
  userId: 7,
  Breakpoint: 9,
  ViewPort: 10,
  WithDesign: 11,
  DefaultBlank: 25,
  quotedProductStyle: 26,
  quantity: 27,
  quotedProductColor: 28,
  quotedPrice: 29,
  caveat: 30,
  multiStyle: 31,
  colorCountFront: 32,
  colorCountBack: 33,
  quotedProductCategory: 34,
  clipArtId: 40,
  uploadColorCount: 44,
  uploadColorType: 45,
  RestingScreenClick: 46,
  assistedDesignID: 48,
  designTemplateID: 49,
  artMultiColor: 50,
  labLoadBuyNow: 51,
  labLoadKeyword: 52,
  labLoadComplementaryStyles: 53,
  labLoadOrderOptions: 54,
  orderAnythingProduct: 57,
  labLoadMethod: 61,
  adDecisionClose: 64,
  adPromoSource: 66,
  adSaveIndex: 67,
  firstTimeSaver: 70,
  saveDesignID: 71,
  saveProductStyle: 72,
  saveProductCategory: 73,
  saveProductColor: 74,
  labLoadDesignTemplateID: 75,
  designWithAPro: 78,
  adSwappableClipart: 80,
  postalCodeChange: 83,
  realTimeItemPrice: 85,
  keepShoppingOrderAnythingProduct: 88,
  discontinuedProductStyle: 91,
  saveWithArt: 93,
  unavailableSizes: 95,
  unavailableCoreSizes: 116,
  uploadGamutColorCount: 121,
  changedProductCategory: 126,
  inkMatchCount: 127
};
